"use strict";

const TouchscreenDetail = () => {
    const init = () => {
        if($('.js-touchscreen-detail').length > 0) {
            $(function(){
                showFacades();
            });
            $(document).ready(function () {
                var facades_swiper = new Swiper('#facades .left .image', {
                    onSlideChangeStart: function (swiper) {
                        $('#facades .right .img').removeClass('selected');
                        $('#facades .right .img[data-id="'+swiper.activeIndex+'"]').addClass('selected');
                        gtag('event', 'ENGAGED', {
                            'event_category': 'MEDIA', 
                            'event_label': 'Change Facade - '+$('#facades .right .img[data-id="'+swiper.activeIndex+'"]').text()+' ('+window.location.href+')'
                        });
                    }
                });
                
                $('#facades .right .img').click(function(){
                    $('#facades .right .img').removeClass('selected');
                    $(this).addClass('selected');
                    facades_swiper.slideTo($(this).data('id'), 1000, false);
                    gtag('event', 'ENGAGED', {
                        'event_category': 'MEDIA', 
                        'event_label': 'Change Facade - '+$(this).find('.text').text()+' ('+window.location.href+')'
                    });
                });
                $('#facades .right .img:first-child').click();
            });
                
            $('#facades .right').scroll(function (event) {
                if($(this).scrollTop() == 0){
                    $(this).find('.fade.top').hide();
                }else{
                    $(this).find('.fade.top').show();
                }
            });
            $('#floorplan .right .images').scroll(function (event) {
                if($(this).scrollTop() == 0){
                    $(this).parent().find('.fade.top').hide();
                }else{
                    $(this).parent().find('.fade.top').show();
                }
            });
            $('#interiors .right').scroll(function (event) {
                if($(this).scrollTop() == 0){
                    $(this).find('.fade.top').hide();
                }else{
                    $(this).find('.fade.top').show();
                }
            });
              
            $('#facades .left .readmore span').click(function(){
                $('#facades .left .readmore').hide();
                $('#facades .left .text').addClass('more');
                gtag('event', 'ENGAGED', {
                    'event_category': 'MEDIA', 
                    'event_label': 'Read More - Facades ('+window.location.href+')'
                });
            });
            $('#floorplan .left .readmore span').click(function(){
                $('#floorplan .left .readmore').hide();
                $('#floorplan .left .text').addClass('more');
                gtag('event', 'ENGAGED', {
                    'event_category': 'MEDIA', 
                    'event_label': 'Read More - Floorplan ('+window.location.href+')'
                });
            });
            $('#interiors .left .readmore span').click(function(){
                $('#interiors .left .readmore').hide();
                $('#interiors .left .text').addClass('more');
                gtag('event', 'ENGAGED', {
                    'event_category': 'MEDIA', 
                    'event_label': 'Read More - Interiors ('+window.location.href+')'
                });
            });
              
            window.showFacades = function(){
                $('#detail .home').hide();
                $('#facades').show();
                gtag('event', 'ENGAGED', {
                    'event_category': 'MEDIA', 
                    'event_label': 'Change View - Facades ('+window.location.href+')'
                });
            }
              
            window.showFloorPlan = function(){
                $('#detail .home').hide();
                $('#floorplan').css('display', 'flex');
                gtag('event', 'ENGAGED', {
                    'event_category': 'MEDIA', 
                    'event_label': 'Change View - Floorplan ('+window.location.href+')'
                });
            }
              
            window.showInteriors = function(){
                $('#detail .home').hide();
                $('#interiors').show();
                
                gtag('event', 'ENGAGED', {
                    'event_category': 'MEDIA', 
                    'event_label': 'Change View - Interiors ('+window.location.href+')'
                });
                
                var interiors_swiper = new Swiper('#interiors .left .image', {
                    onSlideChangeStart: function (swiper) {
                        $('#interiors .right .img').removeClass('selected');
                        $('#interiors .right .img[data-id="'+swiper.activeIndex+'"]').addClass('selected');
                        gtag('event', 'ENGAGED', {
                            'event_category': 'MEDIA', 
                            'event_label': 'Change Interior - '+$('#interiors .right .img[data-id="'+swiper.activeIndex+'"]').text()+' ('+window.location.href+')'
                        });
                    }
                });
                $('#interiors .right .img').click(function(){
                    $('#interiors .right .img').removeClass('selected');
                    $(this).addClass('selected');
                    interiors_swiper.slideTo($(this).data('id'), 1000, false);
                    gtag('event', 'ENGAGED', {
                        'event_category': 'MEDIA', 
                        'event_label': 'Change Interior - '+$(this).find('.text').text()+' ('+window.location.href+')'
                    });
                });
                $('#interiors .right .img:first-child').click();
            }
        }
    };

    return {
        init:init
    };
};

export default TouchscreenDetail;